module.exports = __webpack_public_path__ + "img/20200514_154253.13d3b3c1.jpg";